import { Box, ClickAwayListener, Popover } from "@mui/material";
import { Dashboard } from "../../../../../types/files";
import CustomFieldContentCard from "../../../../molecules/home-companies/CustomFieldContentCard";

const CustomFieldModal: React.FC<{
    open: boolean,
    dashboard: Dashboard,
    fieldName: string,
    anchorElement?: HTMLElement|null,
    onClose: () => void,
 }> = ({ open, dashboard, fieldName, anchorElement, onClose }) => {
    return (<>
        <Popover open={open} anchorEl={anchorElement}>
            <ClickAwayListener onClickAway={onClose}>
                <Box width="fit-content" height="fit-content">
                    <CustomFieldContentCard dashboard={dashboard} fieldName={fieldName} />
                </Box>
            </ClickAwayListener>
        </Popover>
    </>);
}

export default CustomFieldModal;